import * as styles from "./styles.css";
import { cn } from "@discovery/classnames";
import { config } from "@discovery/common-dplus/lib/utils/config-types";
export const Shimmer = () => {
    const shortsPathName = window.location.pathname.split("/")[1];
    const path = window.location.pathname;
    const pathName = shortsPathName === "show" ? shortsPathName : path;
    switch (pathName) {
        case config.standardPageRouteFragments.home:
        case "/":
        case "/kids/home":
            return (React.createElement("div", { className: styles.shimmer },
                React.createElement("div", { className: styles.wrap },
                    React.createElement(Header, null),
                    React.createElement(Logo, null),
                    React.createElement(MenuList, null),
                    React.createElement(MenuList, null),
                    React.createElement(MenuList, null),
                    React.createElement(MenuList, null),
                    React.createElement(MenuList, null),
                    React.createElement("br", null),
                    React.createElement("div", { className: styles.wrapCarousel },
                        React.createElement(Content, null),
                        React.createElement(HeroImage, null)),
                    React.createElement("br", null),
                    React.createElement("div", { className: styles.taxonomyDesktop },
                        React.createElement(TaxonomyImages, null)),
                    React.createElement("div", { className: styles.taxonomyMobile },
                        React.createElement(TaxonomyImagesMobile, null)),
                    React.createElement("br", null),
                    React.createElement(Heading, null),
                    React.createElement("div", { className: styles.taxonomyDesktop },
                        React.createElement(RailsOne, null)),
                    React.createElement("div", { className: styles.taxonomyMobile },
                        React.createElement(RailsOneMobile, null)))));
        case "/shorts":
            return (React.createElement("div", { className: styles.shimmer },
                React.createElement(Header, null),
                React.createElement(MenuList, null),
                React.createElement(MenuList, null),
                React.createElement(MenuList, null),
                React.createElement(MenuList, null),
                React.createElement(MenuList, null),
                React.createElement("br", null),
                React.createElement("div", { className: styles.shimmerWrapperforShorts },
                    React.createElement(Taxonomy, null),
                    React.createElement(Taxonomy, null),
                    React.createElement(Taxonomy, null),
                    React.createElement(Taxonomy, null)),
                React.createElement(ShortsCard, null),
                React.createElement(ShortsCard, null),
                React.createElement(ShortsCard, null)));
        case "/mindblown":
            return (React.createElement("div", { className: styles.shimmer },
                React.createElement(Header, null),
                React.createElement(MenuList, null),
                React.createElement(MenuList, null),
                React.createElement(MenuList, null),
                React.createElement(MenuList, null),
                React.createElement(MenuList, null),
                React.createElement(MinBlownCard, null)));
        case "show":
            return (React.createElement("div", { className: styles.shimmer },
                React.createElement("div", { className: styles.wrap },
                    React.createElement(Header, null),
                    React.createElement(Logo, null),
                    React.createElement(MenuList, null),
                    React.createElement(MenuList, null),
                    React.createElement(MenuList, null),
                    React.createElement(MenuList, null),
                    React.createElement(MenuList, null),
                    React.createElement("br", null),
                    React.createElement(HeroImageShow, null),
                    React.createElement("br", null),
                    React.createElement(ShowTabs, null),
                    React.createElement("div", { className: styles.hideHeader },
                        React.createElement(ShowRails, null)),
                    React.createElement("div", { className: styles.showCard },
                        React.createElement(ShowCard, null)),
                    React.createElement("div", { className: styles.showCard },
                        React.createElement(ShowCard, null)),
                    React.createElement("div", { className: styles.showCard },
                        React.createElement(ShowCard, null)),
                    React.createElement("div", { className: styles.showCard },
                        React.createElement(ShowCard, null)))));
        case "/premium":
            return (React.createElement("div", { className: styles.shimmer },
                React.createElement("div", { className: styles.wrap },
                    React.createElement(Header, null),
                    React.createElement(Logo, null),
                    React.createElement(MenuList, null),
                    React.createElement(MenuList, null),
                    React.createElement(MenuList, null),
                    React.createElement(MenuList, null),
                    React.createElement(MenuList, null),
                    React.createElement("br", null),
                    React.createElement(Heading, null),
                    React.createElement("div", { className: styles.taxonomyDesktop },
                        React.createElement(RailsOne, null),
                        React.createElement(RailsOne, null),
                        React.createElement(RailsOne, null)),
                    React.createElement("div", { className: styles.taxonomyMobile },
                        React.createElement(RailsOneMobile, null)),
                    React.createElement(Heading, null),
                    React.createElement("div", { className: styles.taxonomyMobile },
                        React.createElement(RailsOneMobile, null)),
                    React.createElement(Heading, null),
                    React.createElement("div", { className: styles.taxonomyMobile },
                        React.createElement(RailsOneMobile, null)),
                    React.createElement(Heading, null),
                    React.createElement("div", { className: styles.taxonomyMobile },
                        React.createElement(RailsOneMobile, null)))));
        default:
            return React.createElement(React.Fragment, null);
    }
};
export const TaxonomyImages = () => (React.createElement("div", { className: styles.shimmerWrapperForTax },
    React.createElement(Taxonomy, null),
    React.createElement(Taxonomy, null),
    React.createElement(Taxonomy, null),
    React.createElement(Taxonomy, null),
    React.createElement(Taxonomy, null),
    React.createElement(Taxonomy, null)));
export const TaxonomyImagesMobile = () => (React.createElement("div", { className: styles.shimmerWrapperForTax },
    React.createElement(Taxonomy, null),
    React.createElement(Taxonomy, null),
    React.createElement(Taxonomy, null),
    React.createElement(Taxonomy, null)));
export const Rails = () => (React.createElement("div", { className: styles.shimmerWrapper },
    React.createElement(Rail, null),
    React.createElement(Rail, null),
    React.createElement(Rail, null),
    React.createElement(Rail, null)));
export const RailsL = () => (React.createElement("div", { className: styles.shimmerWrapper },
    React.createElement(Rail, null),
    React.createElement(Rail, null),
    React.createElement(Rail, null),
    React.createElement(Rail, null)));
export const PremiumRails = () => (React.createElement("div", { className: styles.shimmerWrapper },
    React.createElement(Rail, null),
    React.createElement(Rail, null),
    React.createElement(Rail, null),
    React.createElement(Rail, null),
    React.createElement(Rail, null)));
export const ShowRails = () => (React.createElement("div", { className: styles.showWrapper },
    React.createElement("div", { className: styles.shimmerWrapperShow },
        React.createElement(Rail, null),
        React.createElement(Rail, null),
        React.createElement(Rail, null),
        React.createElement(Rail, null),
        React.createElement(Rail, null),
        React.createElement(Rail, null),
        React.createElement(Rail, null),
        React.createElement(Rail, null),
        React.createElement(Rail, null),
        React.createElement(Rail, null))));
export const RailsOne = () => (React.createElement("div", { className: styles.shimmerWrapper },
    React.createElement(Rail, null),
    React.createElement(Rail, null),
    React.createElement(Rail, null),
    React.createElement(Rail, null)));
export const RailsOneMobile = () => (React.createElement("div", { className: styles.shimmerWrapper },
    React.createElement(Rail, null),
    React.createElement(Rail, null)));
export const HeroImage = () => (React.createElement("div", { className: cn(styles.shimmerContainer, styles.bannerContainer) },
    React.createElement("span", { className: cn(styles.shine, styles.heroImage) })));
export const HeroImageShow = () => (React.createElement("div", { className: styles.showBannerWrapper },
    React.createElement("div", { className: cn(styles.shimmerContainer, styles.bannerContainerShow) },
        React.createElement("span", { className: cn(styles.shine, styles.heroImageShow) }))));
export const Content = () => (React.createElement("div", { className: cn(styles.shimmerContainer, styles.contentContainer) },
    React.createElement("span", { className: cn(styles.shine, styles.contentH2) }),
    React.createElement("div", { className: styles.Showcontainer },
        React.createElement("span", { className: cn(styles.shine, styles.contentH6) }),
        React.createElement("span", { className: cn(styles.shine, styles.contentH6, styles.gap) })),
    React.createElement("span", { className: cn(styles.shine, styles.contentH4) }),
    React.createElement("span", { className: cn(styles.shine, styles.contentH4) }),
    React.createElement("span", { className: cn(styles.shine, styles.contentH4) })));
export const Heading = () => (React.createElement("div", { className: cn(styles.shimmerContainer, styles.headingContainer) },
    React.createElement("span", { className: cn(styles.shine, styles.contentH4) })));
export const ShowTabs = () => (React.createElement("div", { className: styles.showBannerWrapper },
    React.createElement("div", { className: cn(styles.shimmerContainer, styles.headingContainer) },
        React.createElement("span", { className: cn(styles.shine, styles.contentH4) }))));
export const Header = () => (React.createElement("div", { className: cn(styles.shimmerContainer, styles.humbergerMenuContainer) },
    React.createElement("span", { className: cn(styles.shine, styles.humbergerMenu) })));
export const Logo = () => (React.createElement("div", { className: cn(styles.shimmerContainer, styles.logoContainer) },
    React.createElement("span", { className: cn(styles.shine, styles.logo) })));
export const MenuList = () => (React.createElement("div", { className: cn(styles.shimmerContainer, styles.menuListContainer) },
    React.createElement("span", { className: cn(styles.shine, styles.menuList) })));
export const Taxonomy = () => (React.createElement("div", { className: cn(styles.shimmerContainer, styles.shimmerContainerTaxonomy) },
    React.createElement("span", { className: cn(styles.shine, styles.taxonomyImage) }),
    React.createElement("span", { className: cn(styles.shine, styles.taxonomyContent) })));
export const Rail = () => (React.createElement("div", { className: cn(styles.shimmerContainer, styles.shimmerContainerRail) },
    React.createElement("span", { className: cn(styles.shine, styles.rail) })));
export const ShortsCard = () => (React.createElement("div", { className: cn(styles.shimmerShortsContainer) },
    React.createElement("div", null,
        React.createElement("span", { className: cn(styles.shine, styles.shortsTitle) }),
        React.createElement("span", { className: cn(styles.shine, styles.shortsCard) }))));
export const MinBlownCard = () => (React.createElement("div", { className: cn(styles.grid) },
    React.createElement("span", { className: cn(styles.shine, styles.minBlownCard) }),
    React.createElement("span", { className: cn(styles.shine, styles.minBlownCard) }),
    React.createElement("span", { className: cn(styles.shine, styles.minBlownCard) }),
    React.createElement("span", { className: cn(styles.shine, styles.minBlownCard) }),
    React.createElement("span", { className: cn(styles.shine, styles.minBlownCard) }),
    React.createElement("span", { className: cn(styles.shine, styles.minBlownCard) })));
export const ShowCard = () => (React.createElement("div", { className: styles.Showcontainer },
    React.createElement("span", { className: cn(styles.shine, styles.showList) }),
    React.createElement("span", { className: cn(styles.shine, styles.showTitle) })));

